<template>
  <div>
    <h1 class="redColor text-white pa-3 pl-4">
      {{ $t("ebay_documentation_shipping.title_1") }}
    </h1>
    <div class="pa-4">
      <h2>{{ $t("ebay_documentation_shipping.overview_title") }}</h2>
      <pre>{{ $t("ebay_documentation_shipping.overview_text") }}</pre>
      <hr class="mb-2" />
      <h2>{{ $t("ebay_documentation_shipping.other_countries_title") }}</h2>
      <pre>{{ $t("ebay_documentation_shipping.other_countries_text") }}</pre>
      <hr class="mb-2" />
      <h2>{{ $t("ebay_documentation_shipping.cost_calculation_title") }}</h2>
      <pre>{{ $t("ebay_documentation_shipping.cost_calculation_text") }}</pre>
      <hr class="mb-2" />
      <h2>{{ $t("ebay_documentation_shipping.example_title") }}</h2>
      <pre>{{ $t("ebay_documentation_shipping.example_text") }}</pre>
      <hr class="mb-2" />
      <h2>{{ $t("ebay_documentation_shipping.responsibilities_title") }}</h2>
      <pre>{{ $t("ebay_documentation_shipping.responsibilities_text") }}</pre>
      <hr class="mb-2" />
      <div>
        <!-- Download Button -->
        <div class="mb-3">
          <v-btn color="grey-darken-3">
            <a :href="excelUrl" download class="white--text">
              <v-icon left color="white">mdi-download</v-icon>
              DOWNLOAD EXCEL
            </a>
          </v-btn>
        </div>
      </div>
      <div style="width: 75vw; overflow-x: scroll" class="pr-5">
        <table style="width: max-content; min-width: 100%">
          <thead>
            <tr>
              <th v-for="(col, index) in excelData[0]" :key="index">
                {{ col }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in excelData.slice(1)" :key="rowIndex">
              <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                {{ cell }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      excelData: [],
      excelUrl: "/prezzi-spedizione-estero.xlsx",
    };
  },
  mounted() {
    this.loadExcel();
  },
  methods: {
    async loadExcel() {
      try {
        // Fetch the file as blob
        const response = await fetch("/prezzi-spedizione-estero.xlsx");
        const blob = await response.blob();

        // Convert blob to ArrayBuffer via FileReader
        const arrayBuffer = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsArrayBuffer(blob);
        });

        // Parse the Excel file
        const workbook = XLSX.read(arrayBuffer, { type: "array" });

        // Get first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert sheet to JSON array
        this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      } catch {}
    },
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 1rem;
}
th,
td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: left;
}
thead {
  background-color: #f2f2f2;
}
h2 {
  background-color: #c62828;
  color: white;
}
</style>
